import { React, useState } from "react";
import Person3Icon from '@mui/icons-material/Person3';
import ForumIcon from '@mui/icons-material/Forum';
import BannerBreadcrumb from "../../Components/BannerBreadcrumb";
const Act = () => {
    const [formData, setFormData] = useState({
        name: "",
        email: "",
        phone: "",
        message: "",
        type: "Exam"
    });
    const [loading, setLoading] = useState(false);
    const [success, setSuccess] = useState(false);
    const [error, setError] = useState(null);
    const [fieldErrors, setFieldErrors] = useState({});
    const validate = () => {
        const errors = {};
        if (!formData.name.trim() || !/^[a-zA-Z\s]+$/.test(formData.name)) {
            errors.name = "Name should contain only letters and spaces.";
        }
        if (!/^\d{10}$/.test(formData.phone)) {
            errors.phone = "Phone number must be exactly 10 digits.";
        }
        if (!formData.email.trim() || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
            errors.email = "Please enter a valid email address.";
        }
        if (!formData.message || !formData.message.trim()) {
            errors.message = "Message is required.";
        }
        return errors;
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        if (name === "phone") {
            if (!/^\d*$/.test(value)) return;
        }
        if (name === "name") {
            if (!/^[a-zA-Z\s]*$/.test(value)) return;
        }
        setFormData((prev) => ({
            ...prev,
            [name]: value
        }));
        setFieldErrors((prev) => ({
            ...prev,
            [name]: undefined
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setSuccess(false);
        setError(null);

        const errors = validate();
        setFieldErrors(errors);
        if (Object.keys(errors).length > 0) {
            setLoading(false);
            return;
        }

        setLoading(true);

        try {
            const formBody = new URLSearchParams(formData).toString();
            await fetch("https://script.google.com/macros/s/AKfycbytFPsSA7Ob7jAQVmRXGHReCfkcWZmnCvpOLdSL7Zw3kEIvSn5YoQELdQBZOLJccA0/exec", {
                method: "POST",
                body: formBody,
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                },
            });
            setSuccess(true);
            setFormData({
                name: "",
                email: "",
                phone: "",
                message: "",
                type: "Exam"
            });
        } catch (err) {
            setError("Failed to submit. Please try again.");
        }

        setLoading(false);
    };
    return (
        <>
            <BannerBreadcrumb head={"ACT (American College Testing)"} pagename={"ACT"} />
            <section className="blog-section">
                <div className="container">
                    <div className="row">
                        <div className="col-md-8 loan-eligibility">
                            <p className="loan-elegibility-des mt-0">One common information source that colleges and universities might use to compare all candidates is provided by the ACT, a standardized test that assesses students’ preparation for college. There are five sections in the test: reading, science, math, English, and an optional essay writing portion. The exam lasts 3 hours 35 minutes with writing and 2 hours 55 minutes without writing.<br /><br />
                                For entrance, the majority of undergraduate programs in the US and Canada demand ACT scores. These tests are administered by ACT Inc. and are utilized by colleges and universities in their admissions process. This standardized test has been designed to assess candidates’ writing, verbal, mathematical, and scientific skills.</p>
                            <h5 className="about-head">What Are the Reasons for Considering Taking the Act Exam?</h5>
                            <p className="loan-elegibility-des">The importance of standardized testing in the college admissions process is shown by the emphasis on ACT scores. Students are advised to study carefully for the exam to boost their chances of receiving admission to the universities of their choice, considering the importance placed on these grades. Therefore, having a competitive ACT score may significantly boost a student’s chances of being admitted into esteemed schools and universities in the United States and Canada.</p>
                            <h5 className="about-head">When is the ACT Being Given?</h5>
                            <p className="loan-elegibility-des">Several times a year, the ACT exam is available. The test is accessible for administration in February, April, June, September, October, and December.</p>
                            <h5 className="about-head">Which Subjects Are Included in The Act Curriculum?</h5>
                            <p className="loan-elegibility-des">The ACT test consists of four key sections:
                            </p>
                            <ol className="subhead-ul">
                                <li>English</li>
                                <li>Reading</li><li>Math</li><li>Science</li>
                            </ol>
                            <p className="loan-elegibility-des">Additionally, a 40-minute writing test is optional. A certain number of colleges demand the writing part score. However, that all depends on the course of study you plan to take in college.</p>

                            <h5 className="about-head">How Can I Register for The Act Exam?</h5>
                            <p className="loan-elegibility-des">The steps needed to register for the ACT exam are as follows:</p>
                            <ol className="subhead-ul">
                                <li>Register on the official ACT website</li>
                                <li>Select the exam center and test date.</li>
                                <li>Create your profile and fill out the application request.</li>
                                <li>Submit your paperwork.</li>
                                <li>Get a quick registration confirmation.</li>
                                <li>Pay the examination cost online.</li>
                            </ol>
                            <h5 className="about-head">What Is the Act Scoring Process?</h5>
                            <p className="loan-elegibility-des">The highest possible ACT segment and total score is 36. It is a scaled score, and the scoring is rather intricate. The scores on each test (except writing) range from 1 to 36. The total or final score is calculated by averaging the scores from all parts.</p>
                            <h5 className="about-head">What Is Considered a Good Act Score?</h5>
                            <p className="loan-elegibility-des">A solid ACT score might help you get into your desired college. In general, an ACT score of 20 or higher indicates above-average performance. An ACT score of 30 or above is recommended for admission to competitive universities.</p>
                            <h5 className="about-head">When Will I Obtain My Act Score?</h5>
                            <p className="loan-elegibility-des">You will receive your ACT results in two parts. The results of multiple-choice questions are disclosed two weeks following the test. The essay’s results are available four weeks following the test. ACT scores may arrive late for several reasons. To remain informed, visit their official website.</p>
                            <h5 className="about-head">Should I Take the Act or The Sat?</h5>
                            <p className="loan-elegibility-des">The majority of colleges and universities do not prefer one test over the other and will accept results from both the ACT and the SAT. In 2016, a few changes to the SAT made it easier than ever to carry on preparing for both tests to acquire competitive ACT and SAT scores.<br /><br />
                                Taking a timed, comprehensive practice exam of both is the best method to make a decision. Because the content and structure of both exams are fairly similar, factors such as how you manage your time and which kind of questions you find more difficult might help you evaluate which test is a better fit for you.</p>
                            <h5 className="about-head">How Can I Effectively Prepare for The Act?</h5>
                            <p className="loan-elegibility-des">The following are crucial methods when preparing for the ACT exam:</p>
                            <ol className="subhead-ul">
                                <li>Get familiar with the ACT’s structure and format.</li>
                                <li>Get familiar with ACT’s question styles</li>
                                <li>Identify your flaws and improve on them.</li>
                                <li>Set a target score</li>
                                <li>Make a study strategy and stick to it.</li>
                                <li>Practice with mock exam papers.</li>
                                <li>Improve your English skills.</li>
                                <li>Practice mathematics. </li>
                            </ol>
                            <p className="loan-elegibility-des">Are you thinking about studying overseas? Credere can assist you in every stage of your abroad education journey. We provide experienced admission counseling as well as support with test preparation, college shortlisting, and other matters.<br /><br />
                                Furthermore, we can assist you in obtaining a study abroad loan to pay for your abroad education. Contact Credere and be sure that you will receive individual advice and direction from specialists who have extensive expertise in making an abroad education journey simpler for millions of Indian students. </p>
                        </div>
                        <div className="col-md-4">
                            <div className="blog-right">
                                <form className="loan-check-form" style={{ padding: "50px" }} onSubmit={handleSubmit}>
                                    <h4 className="" style={{ fontSize: "20px" }}>Contact Now</h4>
                                    {success && <div className="alert alert-success mt-2">Submitted successfully!</div>}
                                    {error && <div className="alert alert-danger mt-2">{error}</div>}
                                    <div className="row">
                                        <div className="col-md-12 finance-head-form">
                                            <label className="form-label finance-label">Name <span>*</span></label>
                                            <input
                                                type="text"
                                                className="form-control finance-input"
                                                placeholder="E.g. Priya Senger"
                                                name="name"
                                                value={formData.name}
                                                onChange={handleChange}
                                                required
                                            />
                                            {fieldErrors.name && (
                                                <div className="text-danger" style={{ fontSize: "0.9em" }}>{fieldErrors.name}</div>
                                            )}
                                        </div>
                                        <div className="col-md-12 finance-head-form">
                                            <label className="form-label finance-label">Email <span>*</span></label>
                                            <input
                                                type="email"
                                                className="form-control finance-input"
                                                placeholder="E.g. priya@doe.com"
                                                name="email"
                                                value={formData.email}
                                                onChange={handleChange}
                                                required
                                            />
                                            {fieldErrors.email && (
                                                <div className="text-danger" style={{ fontSize: "0.9em" }}>{fieldErrors.email}</div>
                                            )}
                                        </div>
                                        <div className="col-md-12 finance-head-form">
                                            <label className="form-label finance-label">Phone<span>*</span></label>
                                            <input
                                                type="tel"
                                                className="form-control finance-input"
                                                placeholder="E.g. 8888880000"
                                                name="phone"
                                                value={formData.phone}
                                                onChange={handleChange}
                                                required
                                                maxLength={10}
                                            />
                                            {fieldErrors.phone && (
                                                <div className="text-danger" style={{ fontSize: "0.9em" }}>{fieldErrors.phone}</div>
                                            )}
                                        </div>
                                        <div className="col-md-12 finance-head-form">
                                            <label className="form-label finance-label">Message<span>*</span></label>
                                            <textarea
                                                type="text"
                                                className="form-control finance-input"
                                                placeholder="Your message"
                                                name="message"
                                                value={formData.message}
                                                onChange={handleChange}
                                                required
                                            />
                                            {fieldErrors.message && (
                                                <div className="text-danger" style={{ fontSize: "0.9em" }}>{fieldErrors.message}</div>
                                            )}
                                        </div>
                                        <div className="col-12">
                                            <button type="submit" className="loan-btn w-100 mt-3" disabled={loading}>
                                                {loading ? "Submitting..." : "Submit"}
                                            </button>
                                        </div>
                                    </div>
                                </form>

                                <section className="landing-partners mt-5" >
                                    <div className="container">
                                        <div className="row">
                                            <div className="col-md-12">
                                                <h5 className="about-head mb-5 text-center">Our Loan Partners</h5>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-4 mb-4">
                                                <img src="/images/icici-logo.png" alt="Partner Logo" className="img-fluid" />
                                            </div>
                                            <div className="col-md-4 mb-4">
                                                <img src="/images/auxilo-logo.png" alt="Partner Logo" className="img-fluid" />
                                            </div>
                                            <div className="col-md-4 mb-4">
                                                <img src="/images/avanse-logo.png" alt="Partner Logo" className="img-fluid" />
                                            </div>
                                            <div className="col-md-4 mb-4">
                                                <img src="/images/axis-logo.png" alt="Partner Logo" className="img-fluid" />
                                            </div>
                                            <div className="col-md-4 mb-4">
                                                <img src="/images/bob-logo.png" alt="Partner Logo" className="img-fluid" />
                                            </div>
                                            <div className="col-md-4 mb-4">
                                                <img src="/images/hdfc-credila-logo.png" alt="Partner Logo" className="img-fluid" />
                                            </div>
                                            <div className="col-md-4 mb-4">
                                                <img src="/images/union-bank-logo.png" alt="Partner Logo" className="img-fluid" />
                                            </div>
                                            <div className="col-md-4 mb-4">
                                                <img src="/images/idfc-logo.png" alt="Partner Logo" className="img-fluid" />
                                            </div>
                                            <div className="col-md-4 mb-4">
                                                <img src="/images/increc-logo.png" alt="Partner Logo" className="img-fluid" />
                                            </div>
                                            <div className="col-md-4 mb-4">
                                                <img src="/images/mpower-logo.png" alt="Partner Logo" className="img-fluid" />
                                            </div>
                                            <div className="col-md-4 mb-4">
                                                <img src="/images/prodigy-logo.png" alt="Partner Logo" className="img-fluid" />
                                            </div>
                                            <div className="col-md-4 mb-4">
                                                <img src="/images/sbi-logo.png" alt="Partner Logo" className="img-fluid" />
                                            </div>
                                        </div>
                                    </div>
                                </section>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default Act;